import { FC, ReactElement } from 'react';
import styles from './GeneralModal.module.scss';
import { IGeneralModalProps } from './IGeneralModalProps';
import classNames from 'classnames';
import {
  Text,
  IconButton,
} from '@fluentui/react';
import OOSReconciliation from '../OOSReconciliation/OOSReconciliation';
import TransferTiresReconciliation from '../TransferTiresReconciliation/TransferTiresReconciliation';

const GeneralModal: FC<IGeneralModalProps> = ({
  isOpened,
  isTransferTire,
  onDismiss,
  surveyDetails: {
    docNum,
    tireOptixSurveyId,
    glsSurveyId,
    comments,
    dispCode,
    surveyDate,
    plantNo,
    plantName,
  },
  fetchQueueRecords,
  shippingDetails: {
    shipToCustomerId,
    shipToLocId,
    shipToCustomerName,
    shipToLocCode,
  },
  tireDetails: {
    tireId,
  },
}): ReactElement => {
  return (
    <>
      {isOpened && (
        <div className={classNames(styles.detailsWrapper)}>
          <div className={classNames(styles.detailsBackground)}>
            <div
              className={classNames(styles.detailsContainer)}
            >
              <div className={classNames(styles.detailsHeader)}>
                <Text variant="xxLarge" className={styles.highlight}>{ !isTransferTire ? 'OOS Reconciliation' : 'Transfer Tires'}</Text>
                <IconButton
                  id='closeButton'
                  iconProps={{ iconName: 'Cancel' }}
                  title="close"
                  onClick={() => onDismiss()}
                />
              </div>
              <div className={classNames(styles.detailsBody)}>
                { !isTransferTire ? <OOSReconciliation 
                  isSearchable={false}
                  surveyDetails={{
                    docNum,
                    tireOptixSurveyId,
                    glsSurveyId,
                    comments,
                    dispCode,
                    surveyDate,
                    plantName,
                    plantNo,
                  }}
                  fetchQueueRecords={fetchQueueRecords}
                  shippingDetails={{
                    shipToCustomerName,
                    shipToLocCode,
                  }}
                  tireDetails={{
                    tireId,
                  }}
                /> : <TransferTiresReconciliation 
                  isSearchable={false}
                  surveyDetails={{
                    docNum,
                    tireOptixSurveyId,
                    glsSurveyId,
                    comments,
                    dispCode,
                    surveyDate,
                  }}
                  fetchQueueRecords={fetchQueueRecords}
                  shippingDetails={{
                    shipToCustomerName,
                    shipToLocCode,
                    shipToCustomerId,
                    shipToLocId,
                  }}
                  tireDetails={{
                    tireId,
                  }}
                /> }
              </div>
            </div>
          </div>
        </div>
      )

      }
    </>
  );
};

export default GeneralModal;